import { init } from '@fullstory/browser';

export const initFullStory = () => {
  init({
    orgId: 'o-1G54HD-na1',
  });
};
